import {useState, useEffect, useReducer} from 'react';
import log from 'loglevel';

const ACTIONS = {
  NEW: 'new',
  COPY: 'copy',
  SWITCH_CURRENT: 'switch',
  DELETE: 'delete',
  UNDELETE: 'undelete',
  PURGE_ALL: 'purge',

  UPDATE_CONTENT: 'content',

  DELETE_HEIGHT_MAP: 'delete height map',
  DELETE_ALL_HEIGHT_MAPS: 'delete all height maps',
  DELETE_EVERYTHING: 'delete everything'
};

const DEFAULT = {
  meta:{
    title: '',
    subtitle: '',
    created:0,
    modified:0,
    deleted:0
  },

  sitePlanCoords: [],

  poiMarkers: [],

  heightMap: {}
};

const newDefault = () => {
  let def = {...DEFAULT};
  def.meta.created = def.meta.modified = Date.now();
  return def;
};

const DEFAULT_ALLSITES = {current:0, all:[newDefault()], deleted:[]};

const siteSortCompare = (siteA, siteB) => {
  return siteB.meta.modified - siteA.meta.modified;
}

const siteFunctionReducer = (allSites, action) => {
  let updatedSites = {...allSites};

  switch (action.type) {
    case ACTIONS.NEW:
      updatedSites.all.unshift(newDefault());
      updatedSites.current = 0;
    break;
    case ACTIONS.COPY:
      let itemCopy = JSON.parse(JSON.stringify(updatedSites.all[updatedSites.current]));
      itemCopy.meta.title += " Copy";
      itemCopy.meta.created = itemCopy.meta.modified = Date.now();
      updatedSites.all.unshift(itemCopy);
      updatedSites.current = 0;
    break;
    case ACTIONS.SWITCH_CURRENT:
      updatedSites.current = Math.max(Math.min(action.id, updatedSites.all.length), 0);
    break;
    case ACTIONS.DELETE:
      if (action.id == updatedSites.current) {alert('Cannot delete current site'); return allSites;}
      if (!updatedSites.deleted) updatedSites.deleted = [];
      updatedSites.all[action.id].meta.deleted = Date.now();
      updatedSites.deleted = updatedSites.deleted.concat( updatedSites.all.splice(action.id, 1) );
      if (action.id < updatedSites.current)
      {
        // update current to be correct
        updatedSites.current--;
      }
      updatedSites.current = Math.min(updatedSites.current, updatedSites.all.length - 1);
    break;
    case ACTIONS.UNDELETE:
      if (updatedSites.deleted[action.id])
      {
        updatedSites.deleted[action.id].meta.deleted = 0;
        const itemRef = updatedSites.deleted[action.id];
        updatedSites.all = updatedSites.all.concat( updatedSites.deleted.splice(action.id, 1) );
        updatedSites.all.sort(siteSortCompare);
        updatedSites.current = updatedSites.all.indexOf(itemRef);
      }
      else {
        alert('Item not found'); return allSites;
      }
    break;
    case ACTIONS.PURGE_ALL:
      updatedSites.deleted = [];
    break;

    case ACTIONS.UPDATE_CONTENT:
      updatedSites.all[updatedSites.current] = {...action.payload};
      updatedSites.all[updatedSites.current].meta.modified = Date.now();
      const toMove = updatedSites.all.splice(updatedSites.current, 1);
      updatedSites.all.unshift(toMove[0]);
      updatedSites.current = 0;
    break;

    case ACTIONS.DELETE_HEIGHT_MAP:
      updatedSites.all[updatedSites.current].heightMapData = {};
    break;

    case ACTIONS.DELETE_ALL_HEIGHT_MAPS:
      for (let i = 0; i < updatedSites.all.length; i++)
      {
        updatedSites.all[i].heightMapData = {};
      }
      for (let i = 0; i < updatedSites.deleted.length; i++)
      {
        updatedSites.deleted[i].heightMapData = {};
      }
    break;

    case ACTIONS.DELETE_EVERYTHING:
      updatedSites = {current:0, all:[newDefault()], deleted:[]};
    break;
  }

  localStorage.setItem(
    'awi_siteplans',
    JSON.stringify(updatedSites)
  );

  return updatedSites;
}

const useSiteStorage = () => {
  const [allSites, allSitesDispatch] = useReducer(
    siteFunctionReducer,
    JSON.parse(localStorage.getItem('awi_siteplans')) || DEFAULT_ALLSITES
  );

  return [allSites, allSitesDispatch];
}

export {useSiteStorage, siteFunctionReducer, ACTIONS};
